module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ec-Fb-Ga.0bf50b20.png";